export default [{'CARDIOVASCULAR':  [['has', 'HAS'],
                                     ['icc', 'ICC'],
                                     ['arritmia', 'Arritmia'],
                                     ['marcapasso', 'Marcapasso'],
                                     ['coronariopatia', 'Coronariopatia'],
                                     ['iam', 'IAM'],
                                     ['valvopatia', 'Valvopatia'],
                                     ['dvp', 'Vasculopatia Periférica']]},
                {'SISTEMA NERVOSO': [['cefaleia', 'Cefaléia'],
                                     ['avc', 'AVC'],
                                     ['convulsao', 'Convulsão'],
                                     ['psiq', 'Distúrbio Psiquiátrico'],
                                     ['lnp', 'Lesão Nervosa Periférica'],
                                     ['medular', 'Lesão Medular']]},
                    {'RESPIRATÓRIO': [['tabagismo', 'Tabagismo'],
                                     ['asma', 'Asma'],
                                     ['dpoc', 'DPOC'],
                                     ['saos', 'SAOS'],
                                     ['ivas', 'IVAS recente'],
                                     ['tb', 'Tuberculose']]},
               {'GASTROINTESTINAL': [['drge', 'DRGE'],
                                     ['ulcera', 'Úlcera Péptica'],
                                     ['gastrite', 'Gastrite'],
                                     ['vomitos', 'Vômitos'],
                                     ['hepatopatia', 'Hepatopatia'],
                                     ['etilismo', 'Etilismo']]},
                      {'ENDÓCRINO': [['dm1', 'Diabetes tipo 1'],
                                     ['dm2', 'Diabetes tipo 2'],
                                     ['hipotireoidismo', 'Hipotireoidismo'],
                                     ['hipertireoidismo', 'Hipertireoidismo'],
                                     ['obesidade', 'Obesidade'],
                                     ['dislipidemia', 'Dislipidemia']]},
                          {'RENAL': [['ira', 'Insuf Renal Aguda'],
                                     ['irc', 'Insuf Renal Crônica'],
                                     ['dialise', 'Diálise'],
                                     ['calculo', 'Cálculo Renal'],
                                     ['dhe', 'Distúrbio Hidroeletrolítico']]},
                   {'HEMATOLÓGICO': [['transfusao', 'Transfusão Prévia'],
                                     ['anemia', 'Anemia'],
                                     ['coagulopatia', 'Coagulopatia'],
                                     ['tvp', 'TVP prévia']]},
            {'MÚSCULO ESQUELÉTICO': [['lombalgia', 'Lombalgia'],
                                     ['artrite', 'Artrite'],
                                     ['distrofia', 'Distrofia Muscular'],
                                     ['artrose', 'Artrose']]},
]
